export const NAVIGATION_ITEMS = [
  { title: "Restaurants", url: "/dashboard/restaurants" },
  { title: "Lists", url: "/dashboard/lists" },
  { title: "Featured", url: "/dashboard/featured" },
  { title: "Settings", url: "/dashboard/settings" },
] as const;
